
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/visitor/why",
      function () {
        return require("private-next-pages/visitor/why/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/visitor/why"])
      });
    }
  